// Auto Assign hands documents to AI doc routing before a project is picked, and routing can
// only read these formats.
export const AUTO_ASSIGN_FILE_EXTENSIONS = [
  'pdf',
  'tif',
  'tiff',
  'jpg',
  'jpeg',
  'png',
]

// Only MIME types are exposed while a drag is in progress, so the drop zone gates on these.
// A type the gate doesn't recognize is refused outright, so the legacy and non-standard
// spellings belong here too — leaving one out blocks a file the name check would have
// accepted, which is the more damaging way to be wrong.
export const AUTO_ASSIGN_MIME_TYPES = [
  'application/pdf',
  'image/tiff',
  'image/tif',
  'image/x-tiff',
  'image/jpeg',
  'image/jpg',
  'image/pjpeg',
  'image/png',
  'image/x-png',
]

export const AUTO_ASSIGN_FILE_ACCEPT = AUTO_ASSIGN_FILE_EXTENSIONS.map(
  (extension) => `.${extension}`,
).join(',')

export const AUTO_ASSIGN_FILE_LABEL = 'PDF, TIFF, JPEG, and PNG'

// A leading dot is the whole name of a hidden file, not an extension, so the dot has to be
// past the first character to count.
function getFileExtension(fileName: string) {
  const lastDotIndex = fileName.lastIndexOf('.')
  return lastDotIndex > 0 ? fileName.slice(lastDotIndex + 1).toLowerCase() : ''
}

export function splitFilesByAcceptedType(
  files: FileList | File[],
  acceptedExtensions: string[],
) {
  const accepted: File[] = []
  const rejected: File[] = []

  Array.from(files).forEach((file) => {
    if (acceptedExtensions.includes(getFileExtension(file.name))) {
      accepted.push(file)
    } else {
      rejected.push(file)
    }
  })

  return { accepted, rejected }
}
